import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import MDBox from "components/MDBox";
import {
  useCustWhOptionsQuery,
  useZoneOptionsQuery,
  useLocationOptionsQuery,
  useSKUOptions,
} from "hooks/useQueryHook";

import { useQuery } from "@tanstack/react-query";
import { getPackTypeUOM, getVendorSKUByCode } from "services/data.internal.service";
import { ReadOnlyTextField } from "ui-components/Form";
import { conditionOptions } from "layouts/views/common/options";
import { numberValidation } from "layouts/views/common/validation";
import { useFieldArray } from "react-hook-form";
import RecvSerialNumber from "./RecvSerialNumber";
function ReceivingDetail({
  detailRender,
  values,
  control,
  errors,
  setValue,
  getValues,
  mode = "ADD",
  serialAlert,
}) {
  const { customerCode, skuCode, vendorCode, recvWh, recvZone } = values;
  const [status, newItem, mlnCtrl, manualLotCtrl, manDateCtrl, expiryDateCtrl, inbSerialNbrCtrl, serialNumbers, quantity] = getValues([
    "status",
    "newItem",
    "mlnCtrl",
    "manualLotCtrl",
    "manDateCtrl",
    "expiryDateCtrl",
    "inbSerialNbrCtrl",
    "serialNumbers",
    "quantity"
  ]);
  const { fields,append,remove } = useFieldArray({ name: "serialNumbers", control });
  const [skuOptions, setSKUOptions] = useState([]);
  const [uomOptions, setUOMOptions] = useState([]);
  const [whOptions, setWhOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [locOptions, setLocOptions] = useState([]);

  // useEffect(() => {
  //   if (qtyReceived === 0 || uom === null) return;
  //   const quantity = qtyReceived * (uom ? uom.value : 0);
  //   console.log(quantity);
  //   setValue("quantity", quantity);
  //   console.log(qtyReceived);
  //   console.log(uom);
  // }, [qtyReceived, uom]);

  const onSKUChange = (e, option) => {
    setUOMOptions([]);
    setValue("packType", null);
    setValue("uom", null);
    setValue("qtyReceived", 0);
    setValue("quantity", 0);
    setValue("recvWh", null);
    setValue("recvZone", null);
    setValue("recvLocation", null);
    //update skucode
    setValue("skuCode", option.value);
    setValue("mlnCtrl", option.mlnCtrl);
    setValue("expiryDateCtrl", option.expiryDateCtrl);
    setValue("manDateCtrl", option.manDateCtrl);
    setValue("manualLotCtrl", option.manualLotCtrl);
    setValue("currencyCode", option.currencyCode);
    setValue("inbSerialNbrCtrl", option.inbSerialNbrCtrl);
    setValue("serialNumbers", []);
  };
  const onUOMChange = (e, option) => {
    const quantity = getValues("qtyReceived") * option?.value??0;
    setValue("quantity", quantity);
    setValue("uom", option,{shouldDirty:true});
    if (inbSerialNbrCtrl && quantity != serialNumbers.length){
      const filteredSerial = serialNumbers.filter(x => Boolean(x.serialNumber));
      if (quantity > filteredSerial.length){
        const emptyItems = Array.from({ length: quantity - filteredSerial.length }, () => ({ serialNumber: "", newItem: true, active: true }));
        setValue("serialNumbers", [...filteredSerial, ...emptyItems]);
      }
      else {
        setValue("serialNumbers", [...filteredSerial])
      }
    }
  };
  const onQtyChange = (e) => {
    const { value } = e.target;
    const qty = numberValidation(value)
    setValue("qtyReceived", qty,{shouldDirty:true});
    const uom = getValues("uom");
    const quantity = qty * (uom ? uom.value : 0);
    setValue("quantity", quantity);
    
    if (inbSerialNbrCtrl && quantity != serialNumbers.length){
      const filteredSerial = serialNumbers.filter(x => Boolean(x.serialNumber));
      if (quantity > filteredSerial.length){
        const emptyItems = Array.from({ length: quantity - filteredSerial.length }, () => ({ serialNumber: "", newItem: true, active: true }));
        setValue("serialNumbers", [...filteredSerial, ...emptyItems]);
      }
      else {
        setValue("serialNumbers", [...filteredSerial])
      }
    }
  };
  useSKUOptions({
    customerCode,
    onSuccess: (data) => {
      setSKUOptions(
        data.data.data.map((x) => ({
          value: x.skuCode,
          label: x.skuCode,
          mlnCtrl: x.mlnCtrl,
          expiryDateCtrl: x.expiryDateCtrl,
          manDateCtrl: x.manDateCtrl,
          manualLotCtrl: x.manualLotCtrl,
          currencyCode: x.currencyCode,
          inbSerialNbrCtrl: x.inbSerialNbrCtrl,
        }))
      );
    },
  });
  useQuery({
    queryKey: ["pack-type-uom", { skuCode, customerCode, vendorCode }],
    queryFn: () => getPackTypeUOM({ skuCode, customerCode, vendorCode }),
    enabled: Boolean(skuCode && customerCode && vendorCode && status === "Open"),
    onSuccess: (data) => {
      const { packType, baseUOM, uomOptions: options } = data.data.data;
      setValue("packType", packType);
      setValue("baseUOM", baseUOM);
      setUOMOptions(
        options.map((x) => {
          return {
            value: x.upm,
            label: x.uom,
          };
        })
      );
    },
  });
  useQuery({
    queryKey: ["vendor-sku", { customerCode, skuCode, vendorCode }],
    queryFn: () => getVendorSKUByCode({ customerCode, skuCode, vendorCode }),
    enabled:
      (mode === "ADD" || (mode === "EDIT" && newItem === true)) &&
      customerCode !== null &&
      skuCode !== null &&
      vendorCode !== null,
    onSuccess: (data) => {
      const { defRecvWh, defRecvZone, defRecvLocation } = data.data.data;

      if (getValues("recvWh") === null) setValue("recvWh", defRecvWh);
      if (getValues("recvZone") === null) setValue("recvZone", defRecvZone);
      if (getValues("recvLocation") === null) setValue("recvLocation", defRecvLocation);
    },
  });
  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => setWhOptions(data.data.data),
  });
  useZoneOptionsQuery({
    whCode: recvWh,
    zoneType: "staging",
    enabled: Boolean(recvWh && status === "Open"),
    onSuccess: (data) => setZoneOptions(data.data.data),
  });
  useLocationOptionsQuery({
    whCode: recvWh,
    zoneID: recvZone,
    enabled: Boolean(recvWh && recvZone && status === "Open"),
    onSuccess: (data) => setLocOptions(data.data.data),
  });
  const onZoneChange = (e, option) => {
    setLocOptions([]);
    setValue("recvZone", option);
    setValue("recvLocation", null);
  };
  const onWarehouseChange = (e, option) => {
    setZoneOptions([]);
    setLocOptions([]);
    setValue("recvWh", option);
    setValue("recvZone", null);
    setValue("recvLocation", null);
  };
  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = property.xs ?? 6 / 2;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" &&
        newItem === false &&
        editable === false && { disabled: true, type: "text" }),
      ...(status !== "Open" && { type:"readonly" }),
      ...(data.name === "qtyReceived" && { onChange: onQtyChange }),
      ...(data.name === "manufacturingDate" && Boolean(manDateCtrl) && { required: true }),
      ...(data.name === "mln" && Boolean(mlnCtrl) && { required: true }),
      ...(data.name === "manualLot" && Boolean(manualLotCtrl) && { required: true }),
      ...(data.name === "expiryDate" && Boolean(expiryDateCtrl) && { required: true }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "readonly":
        renderField = <ReadOnlyTextField field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "skuCode":
            options = skuOptions;
            onChange = onSKUChange;
            break;
          case "recvWh":
            options = whOptions;
            onChange = onWarehouseChange;
            break;
          case "recvZone":
            options = zoneOptions;
            onChange = onZoneChange;
            break;
          case "recvLocation":
            options = locOptions;
            break;
          case "uom":
            options = uomOptions;
            onChange = onUOMChange;
            break;
          case "condition":
            options = conditionOptions;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
      case "multi-select":
        switch (data.name) {
          case "serialNumbers":
            renderField = Boolean(inbSerialNbrCtrl) ? (
              <RecvSerialNumber
                data={fields}
                append={append}
                remove={remove}
                control={control}
                errors={errors}
                serialNumbers={serialNumbers}
                quantity={quantity}
                alert={serialAlert}
                setValue={setValue}
              />
            ) : (
              <></>
            );
            break;
        }
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle
        title={mode === "EDIT" ? "Edit MISC Receiving Detail" : "Add MISC Receiving Detail"}
      />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default ReceivingDetail;
